import React from 'react';
import { Box } from '@mui/material';
import CustomItemReport from '../../components/Reports/CustomItemReport';

// Route wrapper for /reports/custom-item-report (see App.tsx).
const CustomItemReportPage: React.FC = () => {
  return (
    <Box>
      <CustomItemReport />
    </Box>
  );
};

export default CustomItemReportPage;
